import InboundCasePage from './InboundCasePage'

export default InboundCasePage